// Import Estilo
import './index.scss';

// Import Bibliotecas
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function BtnVoltar() {
    const navigate = useNavigate();

    const handleVoltar = () => {
        if (window.history.length > 1) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            navigate(-1);
        } else {
            navigate('/menu');
        }
    };

    return (
        <div className="btn-voltar">
            <button onClick={handleVoltar}><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.3657 15.1657C10.2157 15.3156 10.0122 15.3999 9.8001 15.3999C9.58797 15.3999 9.38452 15.3156 9.2345 15.1657L5.6345 11.5657C5.48452 11.4157 5.40027 11.2122 5.40027 11.0001C5.40027 10.7879 5.48452 10.5845 5.6345 10.4345L9.2345 6.83447C9.38538 6.68875 9.58746 6.60811 9.79722 6.60993C10.007 6.61176 10.2076 6.69589 10.356 6.84422C10.5043 6.99254 10.5884 7.1932 10.5902 7.40295C10.5921 7.61271 10.5114 7.81479 10.3657 7.96567L8.2001 10.2001L15.8001 10.2001C16.0123 10.2001 16.2158 10.2844 16.3658 10.4344C16.5158 10.5844 16.6001 10.7879 16.6001 11.0001C16.6001 11.2122 16.5158 11.4157 16.3658 11.5658C16.2158 11.7158 16.0123 11.8001 15.8001 11.8001L8.2001 11.8001L10.3657 14.0345C10.5157 14.1845 10.5999 14.3879 10.5999 14.6001C10.5999 14.8122 10.5157 15.0157 10.3657 15.1657Z" fill="black" stroke="black" />
                <circle cx="11" cy="11" r="9.25" stroke="black" stroke-width="2.5" />
            </svg>
                Voltar</button>
        </div>
    );
}